import {
  KLARNA,
  MASTERCARD,
  SCHEME,
  VISA,
  IDEAL,
  APPLEPAY,
  TRUSTLY,
  PAY_PO,
  PAY_PAL,
  ONLINE_BANKING_PL,
  MOBILEPAY,
  BLIK,
} from '../../../../state/checkoutPage/paymentAdyen/constants/providerTypes';

export const paymentOptionsLogos = {
  klarna: 'klarna.svg',
  visa: 'visa_logo.svg',
  mastercard: 'mastercard_logo.svg',
  ideal: 'ideal.svg',
  trustly: 'trustly.png',
  kammerkollegiet: 'kammerkollegiet.svg',
  mobilepay: 'mobilepay.svg',
  nets: 'nets.svg',
  onlineBanking_PL: 'onlineBankingPL.svg',
  paypal: 'paypalLogo.svg',
  paypo: 'paypo.svg',
  applepay: 'applepay.svg',
  scheme: ['visa_logo.svg', 'mastercard_logo.svg'],
  CreditCard: ['visa_logo.svg', 'mastercard_logo.svg'],
  CreditCard2: ['visa_logo.svg', 'mastercard_logo.svg'],
  blik: 'blik.svg',
};

export const getAllowedPaymentOptionsLogos = (allowedPaymentOptions) => {
  let logos = [];
  allowedPaymentOptions &&
    allowedPaymentOptions.forEach((paymentOption) => {
      if (paymentOptionsLogos[paymentOption.type] && Array.isArray(paymentOptionsLogos[paymentOption.type])) {
        paymentOptionsLogos[paymentOption.type].forEach((logoImg) => {
          logos.push({
            logoImg: require(`static/images/logos/payments/${logoImg}`),
            style: getLogoStyle(paymentOption.type),
          });
        });
      } else if (Array.isArray(paymentOption.type)) {
        paymentOption.type.forEach((type) => {
          Array.isArray(paymentOptionsLogos[type])
            ? paymentOptionsLogos[type].forEach((logoImg) => {
                logos.push({
                  logoImg: require(`static/images/logos/payments/${logoImg}`),
                  style: getLogoStyle(type),
                });
              })
            : logos.push({
                logoImg: require(`static/images/logos/payments/${paymentOptionsLogos[type]}`),
                style: getLogoStyle(type),
              });
        });
      } else {
        paymentOptionsLogos[paymentOption.type] &&
          logos.push({
            logoImg: require(`static/images/logos/payments/${paymentOptionsLogos[paymentOption.type]}`),
            style: getLogoStyle(paymentOption.type),
          });
      }
    });

  return logos;
};

export const getLogoStyle = (logo) => {
  switch (logo) {
    case KLARNA:
      return { height: '12px' };
    case VISA:
    case MASTERCARD:
    case SCHEME:
    case APPLEPAY:
    case MOBILEPAY:
      return { height: '20px' };
    case IDEAL:
      return { height: '28px' };
    case TRUSTLY:
    case BLIK:
    case ONLINE_BANKING_PL:
      return { height: '17px' };
    case PAY_PO:
      return { height: '30px' };
    case PAY_PAL:
      return { height: '15px' };
    default:
      return { height: '12px' };
  }
};
